import React, {ReactNode} from "react";
import {Container, Text} from "../../../../ui";
import {Dialog} from "../../../bounce-ui";

interface IPreCancelPlanDialogContent {
  username?: string;
  buttonText?: string;
  firstParagraph: ReactNode;
  secondParagraph: ReactNode;
  handleClickProceed: () => void;
  openCancelPlanDialog: () => void;
}

export const PreCancelPlanDialogContent = ({
  username,
  buttonText,
  firstParagraph,
  secondParagraph,
  handleClickProceed,
  openCancelPlanDialog,
}: IPreCancelPlanDialogContent) => {
  const title = username ? `${username}, explore your options before you cancel` : "Explore your options before you cancel";

  return (
    <Dialog
      title={title}
      hasCenteredTitle
      buttonText={buttonText}
      onClick={handleClickProceed}
      secondaryButtonText={"I'd still like to cancel"}
      onClickSecondary={openCancelPlanDialog}
    >
      <Container fullWidth sx={{gap: "8px", alignItems: "start", overflow: "auto"}}>
        <Text>{firstParagraph}</Text>
        <Text>{secondParagraph}</Text>
      </Container>
    </Dialog>
  );
};
